/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'device-xs': {
    width: 16,
    height: 16,
    viewBox: '5 0 13 24',
    data: '<path pid="0" d="M16 18H7V4h9m-4.5 18a1.5 1.5 0 01-1.5-1.5 1.5 1.5 0 011.5-1.5 1.5 1.5 0 011.5 1.5 1.5 1.5 0 01-1.5 1.5m4-21h-8A2.5 2.5 0 005 3.5v17A2.5 2.5 0 007.5 23h8a2.5 2.5 0 002.5-2.5v-17A2.5 2.5 0 0015.5 1z"/>'
  }
})
